var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.802 16.7796L12.2965 3.73887C11.7336 2.76941 10.2638 2.73814 9.70089 3.73887L2.19542 16.7796C1.63251 17.7491 2.35178 19 3.50888 19H18.4886C19.6456 19 20.3649 17.7804 19.802 16.7796ZM11.0144 14.0589C11.7962 14.0589 12.4529 14.7156 12.4529 15.4974C12.4529 16.3105 11.7962 16.936 11.0144 16.936C10.2013 16.936 9.5758 16.3105 9.5758 15.4974C9.5758 14.7156 10.2013 14.0589 11.0144 14.0589ZM9.63835 8.89888C9.60707 8.67997 9.79471 8.49233 10.0136 8.49233H11.9838C12.2027 8.49233 12.3904 8.67997 12.3591 8.89888L12.1402 13.152C12.1089 13.3709 11.9525 13.496 11.7649 13.496H10.2325C10.0449 13.496 9.88853 13.3709 9.85726 13.152L9.63835 8.89888Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.af9c59e3340d92cad2469189cc27821e.svg";
export { ForwardRef as ReactComponent };